import { ShoppingCartOutlined,CloseOutlined } from '@mui/icons-material'
import { Avatar } from 'antd';
import NotificationBell from './NotificationBell';
import React, { useState, useEffect } from 'react'
import './topbar.css'
import logo from './../../assets/logo_doe-removebg-preview.png'
import rdc from './../../assets/stock-vector.jpg'
import { UserOutlined,MenuOutlined,ArrowLeftOutlined,SwapOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { toggleSidebar } from '../../redux/userRedux';
import { getPanier, subscribe, panierCount } from '../../pages/varianteProduit/panier';
import usePermissions from '../../hooks/usePermissions';
import { lireCasquette, ecrireCasquette } from '../../hooks/useCasquette';
import { confirmLeave } from '../../utils/formGuard';

const Topbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Casquette : ce bandeau n'apparaît que pour un LIVREUR à profil mixte qui a
  // basculé côté vendeur — il lui rappelle sa casquette et lui rend ses livraisons.
  const { role: roleReel, profilMixte } = usePermissions();
  const estLivreurEnVendeur = roleReel === 'livreur' && profilMixte && lireCasquette() === 'vendeur';
  // Badge panier branché sur le vrai panier catalogue (localStorage), avec
  // mise à jour live. Avant : state.cart.quantite (Redux mort, toujours 0).
  const [panierLines, setPanierLines] = useState(getPanier());
  useEffect(() => subscribe(setPanierLines), []);
  const quantite = panierCount(panierLines);
  const user = useSelector((state) => state.user.currentUser.username);
  const isSidebarOpen = useSelector((state) => state.user.isSidebarOpen);

  const handleClick = () => {
    dispatch(toggleSidebar());
  };

  // Chevron retour (mobile) : respecte la garde formulaire ; si la pile est
  // vide (arrivée directe / lien externe), on retombe sur l'accueil.
  const goBack = (e) => {
    e.stopPropagation();
    if (!confirmLeave()) return;
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate('/');
  };

  return (
    <>
      <div className="topbar">
        <div className="topbar-left" onClick={()=>navigate('/')}>
          {pathname !== '/' && (
            <button type="button" className="topbar-back" onClick={goBack} aria-label="Retour">
              <ArrowLeftOutlined />
            </button>
          )}
          <img src={logo} alt="" className="topbar-img" />
          <span className="logo">Ndoé Boutique</span>
        </div>
        <div className="topbar-right">
          {/* PROFIL MIXTE : un livreur en casquette vendeur revient à ses
              livraisons d'un tap. Le rôle réel reste « livreur » (le serveur en
              est l'autorité) ; seule la navigation bascule. */}
          {estLivreurEnVendeur && (
            <button type="button" className="topbar-casquette" onClick={() => ecrireCasquette('livreur')}>
              <SwapOutlined /> Mode vendeur — revenir aux livraisons
            </button>
          )}
        { quantite > 0 &&
          <div className="topbar-icons" onClick={()=>navigate('/cart')}>
            <ShoppingCartOutlined/>
            <span className="topbar-not">{quantite}</span>
          </div>}
          <NotificationBell className="topbar-icons topbar-bell" />
          <div className="topbar-icons" style={{border: "1px solid #c2c2c2bb", background:'#f2f2f2'}}>
            <img src={rdc} alt="" className="topbar-imgUser"/> 
          </div>
          <div className="icons-user">
            {/* <img src={logo} alt="" className="topbar-imgUser"/> */}
            <Avatar icon={<UserOutlined />} className='icon_ant'/>
            <span className='username'>{user}</span>
          </div>
          <div className={`topbar-icon ${isSidebarOpen ? 'colorRed' : ''}`} onClick={handleClick}>
            {isSidebarOpen ? <CloseOutlined style={{color:'red'}} className='close-icon'/> : <MenuOutlined /> }
          </div>
        </div>
      </div>
    </>
  )
}

export default Topbar